export default "__VITE_ASSET__CDB$K2$C__"